/* eslint-disable react/no-array-index-key */
/* eslint-disable sort-keys */
import React from 'react'

import Carousel from '../../components/CarouselComponent/CarouselComponent'
import { useLayoutSettings } from '../../hooks/useLayoutSettings'
import Hero5050 from '../Hero5050/Hero5050'
import HeroContainer from '../HeroContainer/HeroContainer'
import HeroFullBanner from '../HeroFullBanner/HeroFullBanner'
import { carouselHeroStyling } from './HeroCarousel.module.css'

const HeroCarousel = ({ lang, slice }) => {
  const { slide } = slice
  const data = useLayoutSettings().filter((item) => item.language.slug === lang)
  const {
    layoutsettings: {
      carouselslides: { fullscreenhero, herohalf },
    },
  } = data[0]

  const { fullslidecontent, fullslideimagedesktop, fullslideimagemobile } =
    fullscreenhero
  const {
    halfstep1,
    halfstep2,
    halfstep3,
    slidecontenthalf,
    slideheadinghalf,
    slideimagehalf,
  } = herohalf

  const slide1 = {
    fieldGroupName: 'hero5050',
    slideheadinghalf,
    slidecontenthalf,
    slideimagehalf,
    halfstep1,
    halfstep2,
    halfstep3,
  }
  const slide2 = {
    fieldGroupName: 'heroFullAlternate',
    slideheadinghalf,
    slidecontenthalf,
    fullslidecontent,
    fullslideimagedesktop,
    fullslideimagemobile,
  }

  const slidesMap = {
    hero5050: Hero5050,
    heroFullAlternate: HeroFullBanner,
    herocontent: HeroContainer,
  }

  const slides = [slide1, slide2, slide]
  return (
    <Carousel extraClassName={carouselHeroStyling} fullWidth withoutNav>
      {slides.map((slideItem, index) => {
        const SlideComponent = slidesMap[slideItem.fieldGroupName]
        return (
          <SlideComponent
            key={`slice-${index}`}
            component={slide.fieldGroupName}
            lang={lang}
            slice={slideItem}
          />
        )
      })}
    </Carousel>
  )
}

export default HeroCarousel
